module.exports = __webpack_public_path__ + "img/CARD_手.b7d71ac8.png";